import React from 'react';
import Link from 'gatsby-theme-wordpress/src/components/highlighted-pages/link';

export default (props) => (
  <p><Link {...props} /></p>
);
